import {call, put} from "redux-saga/effects";
import validateMethod from "../../../helpers/boda-boda/validation";
import {get} from "lodash";
import {setFormErrorFn} from "../form/actions";
import {createAuthUserAPI, getUserStaffList} from "../../../config/boda-boda/apiUrls.config";
import {setFlashMessage, setPageLoader} from "../ui/actions";
import {callApi} from "../../../helpers/boda-boda/common-helpers/callApi.helpers";

const emptyFn = (...para) => undefined;

function* driverPasswordResetFn(data) {
    const validationResponse = yield call(() => validateMethod(
        get(data, 'payload', {}),
        {
            password: "New Password",
            confirm_password: "Confirm Password",
        },
        {
            password: "required|passwordPolicy",
            confirm_password: "required|same:password",
        },
        {
            "confirm_password.same": "Passwords do not match"
        }
    ));

    console.log(validationResponse._status)

    if (validationResponse._status === false) {
        yield put(setFormErrorFn(`${getUserStaffList.key}_edit`, validationResponse.errors));
        console.log(validationResponse._status)
    }
        
    else {
        yield put(setPageLoader(true));
        yield put(setFormErrorFn(`${getUserStaffList.key}_edit`, []));

        const apiRequestBody = {
            password: get(data, "payload.password", "")
        };

        const userAPIRequest = yield call(() => callApi(`${createAuthUserAPI.url}/${get(data, "payload.userId", "")}`)
            .headers(true)
            .method("put")
            .body(apiRequestBody)
            .send()
        );

        if (userAPIRequest._statue === true) {

            yield put(setPageLoader(false));
            yield put(setFlashMessage({
                status: true,
                message: "Password has changed successfully",
                type: "success",
            }));

            get(data, "payload.historyFn.push", emptyFn)(`/users/driver/edit/${get(data, "payload.staffId", "")}`);
        }
        else {
            if (get(userAPIRequest, "data.statusCode", 0) === 403){
                yield put(setFlashMessage({
                    status: true,
                    message: "Permission denied to access",
                    type: "danger",
                }));
            } else {
                yield put(setFlashMessage({
                    status: true,
                    message: "Something went wrong!!",
                    type: "danger",
                }));
            }
        }
    }

    yield put(setPageLoader(false));
}

export {
    driverPasswordResetFn
}
